import React from "react";
import { SignInContext } from "./context";

export function useSignInHook() {
  return React.useContext(SignInContext)
}